window.addEventListener('load', function () {
  //carrousel produits: filtre catégorie produit
  jQuery( ".tabbable .carousel-tab li button" ).click(function() {
    var label = jQuery(this).data('ga');
    push_carousel_event_to_google('click on product category filter', label);
  });

  //carrousel produits: carrousel sous catégorie produits
  jQuery( ".carousel-item .carousel-card" ).click(function() {
    var label = jQuery(this).data('ga');
    push_carousel_event_to_google('click on sub product category', label);
  });

  //carrousel produits : voir toute la catégorie produit
  jQuery( ".carousel-inner .carousel-tab li button" ).click(function() {
    var label = jQuery(this).data('ga');
    push_carousel_event_to_google('click on product category cta', label);
  });
});

var push_carousel_event_to_google = function(action, label) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'gaEvent',
    'eventCategory': 'product carousel',
    'eventAction': action,
    'eventLabel': label
  });
};

//Make carousel work on mobile
//John (2023-02)
window.addEventListener('load', function () {
  var touchstartX = 0;
  var touchendX = 0;

  function checkDirection(paginations, carousel) {
    if (touchendX < touchstartX){
      updatePagination(paginations ,'next', carousel);
      changeSection('c__mobile', 'next');
    }
    if (touchendX > touchstartX) {
      updatePagination(paginations, 'prev', carousel);
      changeSection('c__mobile', 'prev');
    }
  }

  function init() {
    var isMobile = window.innerWidth < 900;
    if (isMobile) {

      var selectors = document.querySelectorAll('.carousel.slide');


      selectors.forEach(function (selector) {
        var paginations = selector.querySelectorAll('.js-carousel-pagination');

        paginations.forEach(function (pagination) {
          pagination.addEventListener('click', function (_e) {
            changeSectionByNumber(selector, parseInt(_e.target.dataset.slideTo), paginations, _e.target);
          });
        });

        selector.addEventListener('touchstart', function (e) {
          touchstartX = e.changedTouches[0].screenX;
        });

        selector.addEventListener('touchend', function (e) {
          touchendX = e.changedTouches[0].screenX;
          checkDirection(paginations, selector);
        });
      });
    }
  }
  init();
  window.addEventListener('resize', function() {
    init();
  });
});
